export type MountLoadMode = 'fresh-open' | 'as-persisted' | 'refetch' | 'flush-then-refetch';

interface MountLoadInput {
    urlQuoteId: string | undefined;
    sameJourney: boolean;
    persisted: { quoteId: string | undefined; version: number | undefined; saveDirty: boolean };
}

export const decideMountLoadMode = ({ urlQuoteId, sameJourney, persisted }: MountLoadInput): MountLoadMode => {
    if (!sameJourney) return urlQuoteId ? 'fresh-open' : 'as-persisted';
    if (urlQuoteId && urlQuoteId !== persisted.quoteId) return 'fresh-open';
    if (!persisted.quoteId) return 'as-persisted';
    return persisted.saveDirty && persisted.version !== undefined ? 'flush-then-refetch' : 'refetch';
};
